// Website display switches (API migration 0142): may vera.inc show a company's name and
// logo, on the clients page, the homepage marquee and/or the industry pages, plus a
// curation priority. Internal only.
//
// Canonical shapes: `apps/api/src/application/use-cases/company/set-company-website-display/`
// and `.../get-website-display-status/`. The RULE is shared, not copied:
// `checkWebsiteDisplayToggle` / `publicityClauseStatus` in @repo/types.

import type { PublicityClauseStatus } from '@repo/types'

import type { Company } from 'types'

import { createApiCall } from './index'

export interface WebsiteDisplayStatus {
  /** The first Terms version carrying the publicity clause (DRAFT, for counsel review). */
  clauseVersion: string
  /** companyId → highest terms version a current brand-role member accepted. Absent = none. */
  memberTermsVersions: Record<string, string>
  /** userId → email of every staffer who confirmed written permission somewhere. */
  permissionConfirmers: Record<string, string>
}

export interface WebsiteDisplayPatch {
  show_on_website_clients?: boolean
  show_on_website_homepage?: boolean
  show_on_website_industry?: boolean
  /** null clears it (unranked). */
  website_logo_priority?: number | null
  publicity_opt_out?: boolean
  /** Required by the API to turn a switch on when the clause is not on record. */
  confirm_written_permission?: boolean
}

export interface WebsiteDisplayUpdateResult {
  company: Company
  clauseStatus: PublicityClauseStatus
  latestMemberTermsVersion: string | null
}

export const companyWebsiteDisplayApi = {
  status: async (): Promise<WebsiteDisplayStatus> => {
    const response = await createApiCall({ method: 'GET', url: '/internal/companies/website-display' })
    return response.data as WebsiteDisplayStatus
  },
  update: async (companyId: string, patch: WebsiteDisplayPatch): Promise<WebsiteDisplayUpdateResult> => {
    const response = await createApiCall({
      method: 'PATCH',
      url: `/internal/companies/${encodeURIComponent(companyId)}/website-display`,
      data: patch,
    })
    return response.data as WebsiteDisplayUpdateResult
  },
}
